import {
  ToggleButtonGroup,
  ToggleButton,
  Divider,
  SxProps,
} from '@mui/material';

interface IToggleButtons {
  value: string | null;
  onChange: (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => void;
  onBlur?: (event: React.FocusEvent<HTMLButtonElement, Element>) => void;
  groupAriaLabel?: string;
  toggleButtons?: {
    value: string | number;
    label?: string;
  }[];
  sx?: SxProps;
}

const ToggleButtonsSx: SxProps = {
  height: { tablet: '54px', mobile: '48px' },
  borderRadius: '200px',
  backgroundColor: '#fff',
  padding: '4px',
  boxShadow: '0px -1px 10px 0px rgba(0, 0, 0, 0.07)',

  '.MuiToggleButton-root': {
    border: 0,
    borderRadius: 0,
    width: '50%',
    color: 'secondary.dark',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: '400',

    '&:hover': {
      bgcolor: 'transparent',
    },
  },
  '.MuiToggleButton-root.Mui-selected': {
    bgcolor: 'purple2.main',
    color: '#fff',
    borderRadius: '200px',

    '&:hover': {
      bgcolor: 'purple2.main',
    },
  },
};

export const MultiToggleInput = ({
  value,
  onChange,
  onBlur,
  groupAriaLabel,
  toggleButtons = [],
  sx,
}: IToggleButtons) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={onChange}
      aria-label={groupAriaLabel}
      sx={{ ...ToggleButtonsSx, ...sx }}
    >
      {toggleButtons.map((button, index) => (
        <ToggleButton
          value={button.value}
          aria-label={button.label}
          onBlur={onBlur}
          key={index}
        >
          {button.label ? button.label : button.value}
          {value === null && index !== toggleButtons.length - 1 && (
            <Divider
              orientation='vertical'
              flexItem
              sx={{
                borderColor: '#B0B0B0',
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                height: '30px',
              }}
            />
          )}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
